import { OverlayModule } from "@angular/cdk/overlay";
import { NgClass, NgStyle } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NzToolTipComponent } from "ng-zorro-antd/tooltip";

@Component({
  selector: "ui-tooltip",
  exportAs: "uiTooltipComponent",
  templateUrl: "tooltip.component.html",
  preserveWhitespaces: false,
  styleUrls: ["tooltip.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, NgStyle, OverlayModule],
})
export class UiTooltipComponent extends NzToolTipComponent {}
